module.exports = __webpack_public_path__ + "img/media-7.11455009.png";